import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import swal from 'sweetalert2';        

@Component({
  selector: 'app-empleados',
  templateUrl: './empleados.component.html',
  styleUrls: ['./empleados.component.scss']
})
export class EmpleadosComponent implements OnInit {

  loading: boolean = false;
  bregistro = false;
  usu;
  org_;
  itm = {
    id:0,
    nombre:"",
    apaterno:"",
    amaterno:"",
    direccion:"",
    municipio:"",
    estudios:"",
    numerotelefonico:"",
    numerodecelular:"",
    email:"",
    curp:"",
    rfc:"",
  }
  est;selest;
  esc;selesc;
  doc;seldoc;
  ins;selins;
  sex;selsex;
  civ;selciv;

  lst;

  constructor(
    public authService: AuthService,
    public router: Router,    
  ) {     
  }

  ngOnInit(): void {
    //this.usu = this.authService.leerUsuario()    
    this.usu = 0
    if (this.usu != null){
      this.ls_listado();
      this.ls_estados();
      this.ls_escolaridades();
      this.ls_docprobatorios();      
      this.ls_instituciones();

      var _sex = []     
      _sex.push({ id: '-', nombre: '-',});
      _sex.push({ id: 'H', nombre: 'Hombre',});
      _sex.push({ id: 'M', nombre: 'Mujer',});
      this.sex = _sex;
      this.selsex = {id: '-' , nombre: '-' };

      var _civ = []     
      _civ.push({ id: '-', nombre: '-',});
      _civ.push({ id: 'S', nombre: 'Soltero',});
      _civ.push({ id: 'C', nombre: 'Casado',});
      this.civ = _civ;
      this.selciv = {id: '-' , nombre: '-' };

    }
    else{
      this.router.navigate(['/login']);
    }
  }

  ls_estados(){
    var sqry = "";
    sqry = " select" +
           " id, nombre" +
           " from tblestado" +
           " where status <> 'C'" +
           " order by nombre";
    this.loading =  true;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        var _est = []     
        _est.push({ 
          id: 0,
          nombre: '-',
        });
        if (res.length!=0){
          for (let i = 0; i < res.length; i++){
            _est.push({ 
              id: res[i].id,
              nombre: res[i].nombre,
            });
          }
          this.est = _est;
        }
        this.selest = {id: 0 , nombre: '-' };
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    }); 
  }
  ls_escolaridades(){
    var sqry = "";
    sqry = " select" +
           " id, nombre" +
           " from tblescolaridad" +
           " where status <> 'C'" +
           " order by nombre";
    this.loading =  true;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        var _esc = []     
        _esc.push({ 
          id: 0,
          nombre: '-',
        });
        if (res.length!=0){
          for (let i = 0; i < res.length; i++){
            _esc.push({ 
              id: res[i].id,
              nombre: res[i].nombre,
            });
          }
          this.esc = _esc;
        }
        this.selesc = {id: 0 , nombre: '-' };
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    }); 
  }
  ls_docprobatorios(){
    var sqry = "";
    sqry = " select" +
           " id, nombre" +
           " from tbldocprobatorio" +
           " where status <> 'C'" +
           " order by nombre";
    this.loading =  true;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        var _doc = []     
        _doc.push({ 
          id: 0,
          nombre: '-',
        });
        if (res.length!=0){
          for (let i = 0; i < res.length; i++){
            _doc.push({ 
              id: res[i].id,
              nombre: res[i].nombre,
            });
          }
          this.doc = _doc;
        }
        this.seldoc = {id: 0 , nombre: '-' };
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    }); 
  }
  ls_instituciones(){
    var sqry = "";
    sqry = " select" +
           " id, nombre" +
           " from tblinstitucion" +
           " where status <> 'C'" +
           " order by nombre";
    this.loading =  true;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);              
        var _ins = []     
        _ins.push({ 
          id: 0,
          nombre: '-',
        });
        if (res.length!=0){
          for (let i = 0; i < res.length; i++){
            _ins.push({ 
              id: res[i].id,
              nombre: res[i].nombre,
            });
          }
          this.ins = _ins;
        }
        this.selins = {id: 0 , nombre: '-' };
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    }); 
  }
  ls_listado(){
    this.lst = null;
    var sqry;
    sqry = " select" +
          " tblempleado.id,tblempleado.nombre,apaterno,amaterno,direccion,municipio," +
          " idestado,tblestado.nombre as estado,idescolaridad,tblescolaridad.nombre as escolaridad," +
          " estudios,iddocprobatorio,tbldocprobatorio.nombre as docprobatorio," +
          " idinstitucion,tblinstitucion.nombre as institucion," +
          " numerotelefonico,numerodecelular,sexo,email,edocivil,curp,rfc,tblempleado.status,imagen" +
          " from tblempleado" +
          " left join tblestado on (tblestado.id = tblempleado.idestado)" +
          " left join tblescolaridad on (tblescolaridad.id = tblempleado.idescolaridad)" +
          " left join tbldocprobatorio on (tbldocprobatorio.id = tblempleado.iddocprobatorio)" +
          " left join tblinstitucion on (tblinstitucion.id = tblempleado.idinstitucion)" +
          " where tblempleado.status <> 'C'" +
          " order by apaterno,amaterno,tblempleado.nombre";
    this.loading = true;          
    this.authService.ejecuta1(sqry)    
    .then(
        data => {          
          this.loading = false;               
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);              
          if (res.length!=0){
            this.lst = data;   
          }
          else{            
            //swal.fire('No existe información!', '', 'info');            
          }
        },
        error => {
            this.loading = false;
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡Información incorrecta!', '', 'error');
        });  
  }
  
  registro(itm,id){
    this.bregistro = true;
    if (id == 0){
      this.itm.id = 0;
      this.itm.nombre = "";
      this.itm.apaterno = "";
      this.itm.amaterno = "";
      this.itm.direccion = "";
      this.itm.municipio = "";
      this.itm.estudios = "";
      this.itm.numerotelefonico = "";
      this.itm.numerodecelular = "";
      this.itm.email = "";
      this.itm.curp = "";
      this.itm.rfc = "";

      this.selest = {id: 0 , nombre: '-' };
      this.selesc = {id: 0 , nombre: '-' };
      this.seldoc = {id: 0 , nombre: '-' };
      this.selins = {id: 0 , nombre: '-' };
      this.selsex = {id: '-' , nombre: '-' };
      this.selciv = {id: '-' , nombre: '-' };
    }else{      
      this.itm.id = itm.id;
      this.itm.nombre = itm.nombre;
      this.itm.apaterno = itm.apaterno;
      this.itm.amaterno = itm.amaterno;
      this.itm.direccion = itm.direccion;
      this.itm.municipio = itm.municipio;
      this.itm.estudios = itm.estudios;
      this.itm.numerotelefonico = itm.numerotelefonico;
      this.itm.numerodecelular = itm.numerodecelular;
      this.itm.email = itm.email;
      this.itm.curp = itm.curp;
      this.itm.rfc = itm.rfc;

      this.selest = {id: itm.idestado , nombre: itm.estado };
      this.selesc = {id: itm.idescolaridad , nombre: itm.escolaridad };
      this.seldoc = {id: itm.iddocprobatorio , nombre: itm.docprobatorio };
      this.selins = {id: itm.idinstitucion , nombre: itm.institucion };

      var objIndex = this.sex.findIndex(((itm1 :any) => itm1.id == itm.sexo));     
      this.selsex = {id: itm.sexo , nombre: this.sex[objIndex].nombre };
      objIndex = this.civ.findIndex(((itm1 :any) => itm1.id == itm.edocivil));   
      this.selciv = {id: itm.edocivil , nombre: this.civ[objIndex].nombre };
    }

  }

  cancelar(){
    this.bregistro = false;
  }
  guardar(){
    if (this.itm.nombre == ""){
      swal.fire('', '<h5>Proporcione el nombre</h5>', 'warning');
      return;
    }
    if (this.itm.apaterno == ""){
      swal.fire('', '<h5>Proporcione el nombre</h5>', 'warning');
      return;
    }
    if (this.itm.rfc == ""){
      swal.fire('', '<h5>Proporcione el RFC</h5>', 'warning');
      return;
    }
    if (this.itm.curp == ""){
      swal.fire('', '<h5>Proporcione el CURP</h5>', 'warning');
      return;
    }
    if (this.selsex.id == '-'){
      swal.fire('', '<h5>Proporcione el género</h5>', 'warning');
      return;
    }
    if (this.selciv.id == '-'){
      swal.fire('', '<h5>Proporcione el estado civil</h5>', 'warning');
      return;
    }
    if (this.itm.direccion == ""){
      swal.fire('', '<h5>Proporcione la dirección</h5>', 'warning');
      return;
    }
    if (this.itm.municipio == ""){
      swal.fire('', '<h5>Proporcione el municipio</h5>', 'warning');
      return;
    }
    if (this.selest.id == 0){
      swal.fire('', '<h5>Proporcione la entidad federativa</h5>', 'warning');
      return;
    }
    if (this.itm.numerotelefonico == ""){
      swal.fire('', '<h5>Proporcione el número telefónico</h5>', 'warning');
      return;
    }
    if (this.itm.numerodecelular == ""){
      swal.fire('', '<h5>Proporcione el número de celular</h5>', 'warning');
      return;
    }
    if (this.itm.email == ""){
      swal.fire('', '<h5>Proporcione el email</h5>', 'warning');
      return;
    }
    if (this.selesc.id == 0){
      swal.fire('', '<h5>Proporcione la escolaridad</h5>', 'warning');
      return;
    }
    if (this.itm.estudios == ""){
      swal.fire('', '<h5>Proporcione los estudios</h5>', 'warning');
      return;
    }
    if (this.selins.id == 0){
      swal.fire('', '<h5>Proporcione la institución</h5>', 'warning');
      return;
    }

    var sqry;
    if (this.itm.id == 0){
      sqry = " insert into tblempleado (" +
             " nombre,apaterno,amaterno,direccion,municipio,idestado,idescolaridad,estudios," +
             " iddocprobatorio,idinstitucion,numerotelefonico,numerodecelular,sexo,email,edocivil" +
             " curp,rfc,status,imagen)" +
             " values ('" +
             this.itm.nombre + "','" +
             this.itm.apaterno + "','" +
             this.itm.amaterno + "','" +
             this.itm.direccion + "','" +
             this.itm.municipio + "'," +
             this.selest.id + "," +
             this.selesc.id + ",'" +
             this.itm.estudios + "'," +
             this.seldoc.id + "," +
             this.selins.id + ",'" +
             this.itm.numerotelefonico + "','" +
             this.itm.numerodecelular + "','" +
             this.selsex.id + "','" +
             this.itm.email + "','" +
             this.selciv.id + "','" +
             this.itm.curp + "','" +
             this.itm.rfc + "','" +
             "A" + "','" +
             "" + "')";
    }else{
      sqry = " update tblempleado set" +
             " nombre = '" + this.itm.nombre + "'," +
             " apaterno = '" + this.itm.apaterno + "'," +
             " amaterno = '" + this.itm.amaterno + "'," +
             " direccion = '" + this.itm.direccion + "'," +
             " municipio = '" + this.itm.municipio + "'," +
             " idestado = " + this.selest.id  + "," +
             " idescolaridad = " + this.selesc.id  + "," +
             " estudios = '" + this.itm.estudios + "'," +
             " iddocprobatorio = " + this.seldoc.id  + "," +
             " idinstitucion = " + this.selins.id  + "," +
             " numerotelefonico = '" + this.itm.numerotelefonico + "'," +
             " numerodecelular = '" + this.itm.numerodecelular + "'," +
             " sexo = '" + this.selsex.id + "'," +
             " email = '" + this.itm.email + "'," +
             " edocivil = '" + this.selciv.id + "'," +
             " curp = '" + this.itm.curp + "'," +
             " rfc = '" + this.itm.rfc + "'" +
             " where id = " + this.itm.id;
    }
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        this.bregistro = false;
        this.ls_listado();
        if (this.itm.id == 0)
          swal.fire({ icon: "success", title: "Información registrada", showConfirmButton: false, timer: 1000 });
        else
          swal.fire({ icon: "success", title: "Información modificada", showConfirmButton: false, timer: 1000 });
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

  elimiar(id){
    var sqry;
    sqry = " update tblempleado set status = 'C' where id = " + id;
    this.authService.ejecuta1(sqry)
    .then(
      data  => {        
        this.loading =  false;   
        this.bregistro = false;
        this.ls_listado();
        swal.fire({ icon: "success", title: "Registro eliminado", showConfirmButton: false, timer: 1000 });
    },
    error => {
        this.loading =  false;
        swal.fire('Datos incorrectos', '', 'error');
    });
  }

}

